export default "__VITE_ASSET__85ea11f4__"